<template>
  <v-container class="attention-box__container">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <AttentionData
      v-if="isAttentionData"
      value-customers-attention="20"
      value-effectiveness="80%"
    />
    <ActionContainer
      :ticket-list="ticketList"
      :assignment-detail="assignmentDetail"
      :user="user"
      @openAttendCustomerModal="openAttendCustomerModal"
    />
    <v-row>
      <v-col>
        <DataTableTickets
          :headers="headers"
          :items="ticketList"
          :actions="['call']"
          :borderRadius="10"
          :loading="loadingTable"
          :height="350"
          fixed-header
          @callAction="callAction"
          :overlay="overlayTable"
        />
      </v-col>
    </v-row>
    <AttendCustomerModal
      :title="modalAttendCustomer.title"
      :description="modalAttendCustomer.description"
      ref="attendCustomer"
      :is-loading="loadingattendcustomermodal"
      @onAttendCustomer="attendTicket"
      @onCancelAttention="cancelTicket"
    />
    <CustomerInformationModal
      ref="customerInformation"
      title="Información del Cliente"
      :is-loading="loadingcustomerInformation"
      @ok="handleFinalizar"
      @pausar="handlePausar"
    />
    <ConfirmActionModal
      :title="modalConfirm.title"
      ref="confirmAction"
      @ok="callCustomer"
    />
  </v-container>
</template>

<script>
import { ticketStatuses } from '@/domain/global.enum';
import { existCustomersToCall, verifyAssignment } from '@/domain/box/box.model';

import DataTableTickets from '@/infrastructure/vue/components/common/tables/DataTableTickets';
import AttendCustomerModal from '@/infrastructure/vue/components/common/modals/AttendCustomerModal';
import CustomerInformationModal from '@/infrastructure/vue/components/common/modals/CustomerInformationModal.vue';
import ConfirmActionModal from '@/infrastructure/vue/components/common/modals/ConfirmActionModal';
import AttentionData from '@/infrastructure/vue/components/views/box/components/AttentionData';
import ActionContainer from '@/infrastructure/vue/components/views/box/components/ActionContainer';
import { mapGetters } from 'vuex';
import { io } from 'socket.io-client';
import { PATHS } from '@/infrastructure/utils/route-constants';

export default {
  name: 'AttentionBox',
  components: {
    AttentionData,
    ActionContainer,
    DataTableTickets,
    AttendCustomerModal,
    CustomerInformationModal,
    ConfirmActionModal,
  },
  computed: {
    ...mapGetters('login', ['user']),
    ...mapGetters('box', ['ticketList', 'assignmentDetail']),
    disabledCallCustomer() {
      return !existCustomersToCall(this.ticketList);
    },
  },
  data: () => ({
    isAttentionData: false,
    overlay: false,
    overlayTable: false,
    headers: [
      { text: 'Ticket', value: 'attentionTicketCode' },
      { text: 'Nombre', value: 'customerName' },
      { text: 'Cola', value: 'attentionQueueName' },
      { text: 'Prioridad', value: 'priorityName' },
      { text: 'Tiempo transcurrido', value: 'registrationDate' },
      { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' },
    ],
    isVisibleAttendCustomerModal: false,
    dataInformation: null,
    loadingTable: false,
    loadingattendcustomermodal: false,
    loadingcustomerInformation: false,
    loadingBtnCall: false,
    modalAttendCustomer: {
      title: 'Usted está por atender al cliente',
      description: '',
    },
    infoUser: {},
    modalConfirm: {
      title: '¿Usted está seguro se llamar al cliente: ##-##-#####?',
    },
  }),
  methods: {
    async callAction(payload) {
      this.modalConfirm.title = `¿Usted está seguro de llamar al cliente: ${payload.customerName}?`;
      this.$refs.confirmAction.open(payload);
    },
    async callCustomer(payload) {
      if (
        payload.statusCode === ticketStatuses.PAUSE ||
        payload.statusCode === ticketStatuses.ATTENDING
      ) {
        this.attendTicket(payload);
      } else {
        const dataParse = this.handleDataToUpdateTicket(
          payload,
          ticketStatuses.CALLING
        );
        this.overlayTable = true;
        const responseUpdateTicket = await this.$store.dispatch(
          'box/updateTicketAction',
          dataParse
        );
        this.overlayTable = false;
        if (responseUpdateTicket) {
          this.$refs.attendCustomer.open(payload);
          this.modalAttendCustomer.description = payload.customerName;
        }
      }
    },
    handleDataToUpdateTicket(payload, status) {
      const newpayload = {
        ...payload,
        attentionType: this.user.attentionType,
        headquartersCode: this.user.headquartersCode,
        headquartersShort: this.user.headquartersShort,
        attentionTicketStatus: status,
        boxCode: this.assignmentDetail.boxCode,
        attentionTicketCode:
          payload && payload.attentionTicketCode
            ? payload.attentionTicketCode
            : this.ticketList[0].attentionTicketCode,
      };
      return newpayload;
    },
    async attendTicket(payload) {
      this.loadingattendcustomermodal = true;
      this.overlayTable = true;
      const dataParse = this.handleDataToUpdateTicket(
        payload,
        ticketStatuses.ATTENDING
      );
      this.dataInformation = dataParse;
      await this.$store.dispatch('box/updateTicketAction', dataParse);
      this.$refs.attendCustomer.close();
      this.$refs.customerInformation.open(dataParse);
      this.overlayTable = false;
      this.loadingattendcustomermodal = false;
    },
    async cancelTicket(payload) {
      this.loadingattendcustomermodal = true;
      const dataParse = this.handleDataToUpdateTicket(
        payload,
        ticketStatuses.REJECTED
      );
      this.dataInformation = dataParse;
      await this.$store.dispatch('box/updateTicketAction', dataParse);
      this.$refs.attendCustomer.close();
      this.loadingattendcustomermodal = false;
    },
    async handleFinalizar(payload) {
      this.loadingcustomerInformation = true;
      await this.$store.dispatch('box/updateTicketAction', payload);
      this.loadingcustomerInformation = false;
      this.$refs.customerInformation.close();
    },
    async handlePausar(payload) {
      this.loadingcustomerInformation = true;
      await this.$store.dispatch('box/updateTicketAction', payload);
      this.loadingcustomerInformation = false;
      this.$refs.customerInformation.close();
    },
    openAttendCustomerModal(payload) {
      if (payload) {
        this.$refs.attendCustomer.open(payload);
        this.modalAttendCustomer.description = payload.customerName;
      }
    },
  },
  async created() {
    if (verifyAssignment(this.assignmentDetail)) {
      await this.$store.dispatch('ticket/typificationListAction');
      const socket = await io.connect(process.env.VUE_APP_URL_BASE, {
        transports: ['websocket'],
        upgrade: false,
        forceNew: true,
        path: '/attention-queues-streams/socket-io',
      });
      const idSocket = `${this.user.attentionType}-${this.user.headquartersCode}-box-${this.assignmentDetail.boxCode}`;
      if (verifyAssignment(this.assignmentDetail)) {
        socket.emit('recuperarBox', this.assignmentDetail);
      }
      socket.on(idSocket, (data) => {
        this.$store.commit('box/SET_TICKETS_LIST', data.data);
      });
      socket.on(this.user.userCode, (data) => {
        this.$store.commit('box/SET_TICKETS_LIST', data.data);
      });
    } else {
      this.$router.push(`${PATHS.box.pathBase}${PATHS.box.assignmentBox}`);
      this.$store.dispatch('alerts/addAlert', {
        type: 'info',
        message: 'Por favor complete primero la asignación del box.',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.attention-box {
  &__container {
    max-width: 1500px;
    margin: 0 auto;
  }
  &__call-actions {
    margin: 50px 0 30px;
  }
}
</style>
